/* eslint-disable import/prefer-default-export */
export const transformToPercentage = (number, totalNumber) => {
  // eslint-disable-next-line no-restricted-globals
  if (!totalNumber || totalNumber === 0 || isNaN(totalNumber)) return 0;
  // eslint-disable-next-line consistent-return
  return ((number / totalNumber) * 100).toFixed(0);
};
